import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/coursesManagement.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, DatePicker, Tabs, List, ListItem, IconReload, Checkbox, Accordion, AccordionItemInterface, IconX, IconCheckmark, AccordionInterface, IconCheckmarkCircle, Card, CustomImage, ProgressIndicator, RadioButtons, RadioButton, TextArea, FilePicker, DateRange, IconInfo, IconCheckCircle, IconXCircle, Toggle } from "@veneer/core";

import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import CourseManagementEditorModal from "../../components/CourseManagement/CourseManagementEditorModal";
import { ICourseManagementDto } from "../../models/dto/trainingApi/ICourseManagementDto";
import courseService from "../../services/trainingApi/course.service";
import ImageService from "../../services/generalApi/image.service";




export default function CoursesManagement() {

    const params = useParams();
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    const state: any = useSelector((state: RootState) => state.user);
    type SelectValue = number | string | boolean;


    const [loadingTableData, setLoadingTableData] = useState<boolean>(true);
    const [showModalConfirmDeletion, setShowModalConfirmDeletion] = useState<boolean>(false);

    const [search, setSearch] = useState<string>('');
    const [courseId, setCourseId] = useState<number>(NaN);


    const [tableData, setTableData] = useState<TableData[]>([]);
    const [tableDataWithImages, setTableDataWithImages] = useState<TableData[]>([]);
    const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
    let dataCourses: ICourseManagementDto[] = [];
    const imageCache = useRef<{ [key: string]: string }>({}); 

    const [showModalEditor, setShowModalEditor] = useState<boolean>(false);

    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [courseToEdit, setCourseToEdit] = useState<ICourseManagementDto | undefined>(undefined);

    useEffect(() => {
        getCoursesData();
    }, [])

    const getCoursesData = () => {
        setLoadingTableData(true);
        setTableData([]);
        setTableDataFiltered([]);
        try {
            courseService.getCourses()
                .then(r => {
                    fillDataCourses(r);
                    dataCourses = r;
                })
        } catch (error) {
            console.error(error);
        }

    }

    const fillDataCourses = (data: ICourseManagementDto[]) => {
        const pagedData: TableData[] = data.map(course => ({
            courseID: course.courseID,
            coverImageUrl: course.coverImage,
            coverImage: <ProgressIndicator appearance="circular" behavior="indeterminate" />,
            courseName: course.courseName,
            courseDescription: course.courseDescription,
            clasificationID: course.clasificationID,
            categoryID: course.categoryID,
            subCategoryID: course.subCategoryID,
            languageID: course.languageID,
            language: course.language,
            countriesID: course.countriesID,
            prerequisitesID: course.prerequisitesID,
            rolesID: course.rolesID,
            countries: course.countries,
            prerequisites: course.prerequisites,
            roles: course.roles,
            undefined: course.undefined ? <IconCheckCircle /> : <IconXCircle />,
            startDate: formatDateToYearMonthDay(course.startDate),
            endDate: formatDateToYearMonthDay(course.endDate),
            scope: course.scope,
            active: <Toggle id={"toggle"+course.courseID} defaultOn={course.active} onChange={() => handleChangeActive(course.courseID,!course.active)}/>,
            courseMaterial: course.courseMaterial,
            courseEvaluation: course.courseEvaluation,
            rowConfig: {
                action: <ContextualMenu
                    onClick={handleActionRowConfig}
                    options={[
                        { value: course.courseID, label: t("header.edit"), icon: <IconPencil /> },
                        { value: course.courseID, label: t("header.delete"), icon: <IconTrash /> },
                    ]}
                    placement="leading"
                />,
                disabled: false,
                noWrap: false,
                selected: false,
            }
        }));

        setTableData(pagedData);
        setTableDataFiltered(pagedData);
        setLoadingTableData(false);
    };


    const loadImages = async (data: TableData[]) => {
        const updatedTableData = [...data]; 

        const promises = updatedTableData.map(async (item, index) => {
            if (imageCache.current[item.coverImageUrl]) {
                updatedTableData[index].coverImage = (
                    <CustomImage size={180} src={imageCache.current[item.coverImageUrl]} />
                );
                return;
            }

            try {
                const response = await ImageService.getBlobImage(item.coverImageUrl);

                if (response instanceof Blob) {
                    const objectUrl = URL.createObjectURL(response);
                    imageCache.current[item.coverImageUrl] = objectUrl;
                    updatedTableData[index].coverImage = (
                        <CustomImage size={180} src={objectUrl} />
                    );
                } 
            } catch (error) {
                console.error(error);
            }
        });

        await Promise.all(promises);

        setTableDataWithImages(updatedTableData);
        setTableDataFiltered(updatedTableData); 
    };

    useEffect(() => {
        if (tableData.length > 0) {
            loadImages(tableData);
        }
    }, [tableData]);



    function formatDateToYearMonthDay(dateString: Date) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }


    const columns: TableColumns[] = [
        {
            id: 'coverImage',
            label: t("header.cover"),
        },
        {
            id: 'courseName',
            label: t("header.name"),
        },
        {
            id: 'language',
            label: t("header.language"),
        },
        {
            id: 'active',
            label: t("header.active"),
        },
        {
            id: 'countries',
            label: t("header.countries"),
        },
        {
            id: 'prerequisites',
            label: t("header.prerequisite"),
        },
        {
            id: 'roles',
            label: t("header.roles"),
        },
        {
            id: 'startDate',
            label: t("header.stardDate"),
        },
        {
            id: 'endDate',
            label: t("header.endDate"),
        },
        {
            id: 'scope',
            label: t("header.scope"),
        },
    ];



    const handleActionRowConfig = (e: React.SyntheticEvent, option?: OptionInterface) => {
        if (option) {
            if (option.label === "Edit" || option.label === "Editar" || option.label === "Editar") {
                setIsUpdating(true);
                const courseTemp = dataCourses.find(item => item.courseID === Number(option.value));
                if (courseTemp) {
                    setCourseToEdit(courseTemp)
                    setShowModalEditor(true);
                }
            } else if (option.label === "Delete" || option.label === "Eliminar" || option.label === "Excluir") {
                setCourseId(Number(option.value));
                setShowModalConfirmDeletion(true);
            }

        }
    }

    const handleChangeSearch = (value: string) => {
        setSearch(value);
        const filterArray = tableDataWithImages.filter((element) => {
            if (element.courseName.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setTableDataFiltered(filterArray)
    }




    const onCloseEditorModal = () => {
        setIsUpdating(false);
        setCourseToEdit(undefined);
        setShowModalEditor(false);
        getCoursesData()
    }

    const confirmDeletion = () => {
        courseService.deleteCourse(courseId)
            .then(r => {
                setLoadingTableData(true);
                setSearch('');
                getCoursesData();
                setShowModalConfirmDeletion(false);
                setCourseId(NaN);
            })
    }
    const cancelDeletion = () => {
        setCourseId(NaN);
        setShowModalConfirmDeletion(false);
    }

    const handleChangeActive = (courseId: number, active: boolean) => {
        courseService.updateCourseActive(courseId, active)
            .then(r => {
                setLoadingTableData(true);
                setSearch('');
                getCoursesData();
            })
    }


    return (
        <div className="coursesManagement">
            <h4 className="coursesManagementTittle">{t("header.coursesManagement")}</h4>

            <div className="coursesManagementTop">
                <TextBox
                    className="searchCoursesManagementTextbox"
                    id="searchCoursesManagementTextbox"
                    label={t("header.search")}
                    type="search"
                    onChange={handleChangeSearch}
                    value={search}
                />

                <Button disabled={loadingTableData} onClick={() => setShowModalEditor(true)}   >{t("header.createCourse")}</Button>
            </div>

            <Table
                className="coursesManagementTable"
                behavior={{
                    type: 'singlePage',
                }}
                columnResize
                loading={loadingTableData}
                columns={columns}
                data={tableDataFiltered}
                loadingDataLength={10}
                customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
            />

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalCourseConfirmDeletion"
                    align="center"
                    id="modalCourseConfirmDeletion"
                    show={showModalConfirmDeletion}
                    footer={(
                        <ButtonGroup className="modalCoursesConfirmDeletionButtonGroup">
                            <Button onClick={() => confirmDeletion()}>{t("header.confirm")}</Button>
                            <Button onClick={() => cancelDeletion()} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("header.deleteCourse")}
                >
                    <IconTrash size={120} />
                    <br />
                    <b>{t("header.messageDeleteCourse")}</b>

                </Modal>
            </div>



            {showModalEditor && <CourseManagementEditorModal onClose={onCloseEditorModal} isUpdating={isUpdating} courseToEdit={courseToEdit} coursesData={tableData} />}


        </div >
    );
}